// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"218":"component---src-pages-404-tsx","532":"styles","678":"component---src-pages-index-js","682":"component---src-pages-about-js"}[chunkId] + "-" + {"218":"d44432914f1ce61eb764","532":"f205a0ddab02123f153b","678":"c7639ed2b93f151907b1","682":"eca3d86410d79ec1bc89"}[chunkId] + ".js";
};